import { createFileRoute } from '@tanstack/react-router'

import { RedirectOnSignedIn } from '@/pages/sign-in/redirect-on-signed-in'
import { SignUpPage } from '@/pages/sign-up/page'

export const Route = createFileRoute('/sign-up')({
  validateSearch: (search: Record<string, unknown>): { redirect?: string } => {
    return {
      redirect: search.redirect as string,
    }
  },
  component: () => (
    <RedirectOnSignedIn>
      <SignUpPage />
    </RedirectOnSignedIn>
  ),
})
